<template>

  <div class="detail-order-line-container">
    <div class="detail-order-line" @click="open = !open" :class="{ active:open}">
      <div class="detail-order-line-cell">
        <span>{{lineData.trefc}}</span>
      </div>
      <div class="detail-order-line-cell">
        <span>{{lineData.tmod}}</span>
      </div>
      <div class="detail-order-line-cell">
        <span>{{lineData.ttaille}}</span>
      </div>
      <div class="detail-order-line-cell">
        <span>{{lineData.tcol}}</span>
      </div>
      <div class="detail-order-line-cell">
        <span>{{lineData.topt}}</span>
      </div>
      <div class="detail-order-line-cell">
        <span>{{lineData.tqte_cde}}</span>
      </div>
      <div class="detail-order-line-cell">
        <span>{{lineData.tqte_aff}}</span>
      </div>
       <div class="detail-order-line-cell">
        <span>{{lineData.tqte_liv}}</span>
      </div>
      <div class="detail-order-line-cell">
       <span v-if="lineData.tnsoum !== 0"><router-link :to="{name: 'soumission', params: {submission_id: lineData.tnsoum}}">{{lineData.tnsoum}}</router-link></span>
      </div>
      <div class="detail-order-line-cell">
        <span>{{$dateformat(lineData.tdelai_conf)}}</span>
      </div>
    </div>
    <div class="detail-content" v-if="open">
      <div class="grid-row">
        <div class="c-6">
          <div class="order-detail-block">
            <span class="detail-bloc-title">{{$_('details')}}</span>
            <span class="detail-price-unit">{{$_('designation')}} :  <strong>{{detailsData.tlib_mod}}</strong></span>
            <span class="detail-unit">{{$_('packaging_code')}} :  <strong>{{detailsData.topt}}</strong></span>
            <span class="detail-unit">{{$_('your_unit_price')}} :  <strong>{{detailsData.tprix_tunit}}</strong></span>
            <span class="detail-unit">{{$_('quantity_ordered')}} :  <strong>{{detailsData.tqte_cde}}</strong></span>
            <span class="detail-price">{{$_('total')}} : <strong>{{detailsData.tmt_lig}} {{detailsData.tcdev}}</strong></span>
          </div>
        </div>
        <div class="c-6">
          <div class="order-detail-block">
            <span class="detail-customer-delivery">{{$_('desired_customer_deadline')}} : <strong>{{this.$dateformat(detailsData.tdelai_client)}}</strong></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['dataline', 'index'],
  data() {
    return { 
      lineData: {
        trefc: this.$props.dataline.TREFC,
        tmod: this.$props.dataline.TMOD,
        ttaille: this.$props.dataline.TTAILLE,
        tcol: this.$props.dataline.TCOL,
        topt: this.$props.dataline.TLIB_SERIE,
        tqte_cde: this.$props.dataline.TQTE_CDE+' '+this.$props.dataline.TUNIT_QTE,
        tnsoum: this.$props.dataline.TNSOUM,
        tdelai_conf: this.$props.dataline.TDELAI_CONF,
        tqte_aff: this.$props.dataline.TQTE_AFF+' '+this.$props.dataline.TUNIT_QTE,
        tqte_liv: this.$props.dataline.TQTE_LIV+' '+this.$props.dataline.TUNIT_QTE,
      },
      detailsData: {
        tlib_mod: this.$props.dataline.TLIB_MOD,
        topt: this.$props.dataline.TOPT,
        tprix_tunit: this.$props.dataline.TPRIX+' '+this.$store.getters['application/get_application_customer'].TCDEV+' / '+this.$props.dataline.TUNIT_PRIX,
        tqte_cde: this.$props.dataline.TQTE_CDE+' '+this.$props.dataline.TUNIT_QTE,
        tdelai_client: this.$props.dataline.TDELAI_CLIENT,
        total: this.$props.dataline.TQTE_CDE * this.$props.dataline.TPRIX,
        tmt_lig: this.$props.dataline.TMT_LIG,
        tcdev: this.$store.getters['application/get_application_customer'].TCDEV
      },
      open: false
    };
  },
};
</script>

<style scoped>
.detail-order-line {
  display: flex;
  border: solid 1px #e9e9e9;
  margin-top: 10px;
  transition: all 0.3s;
  align-items: center;
}
.detail-order-line-cell{
  display: flex;
  width: calc(100% / 10);
  justify-content: center;
  padding: 25px 0px;
}
.detail-order-line-cell span {
  color: #585858;
  font-size: var(--fz-md);
  transition: all 0.3s;
}
.detail-order-line:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}
.detail-order-line:hover .detail-order-line-cell span {
  color: #8b8b8b;
}
.line-content {
  display: flex;
}
.detail-bloc-title {
  font-weight: bold;
  font-size: var(--fz-md);
  margin-bottom: 5px;
}
.order-detail-block {
  border: solid 1px #E9E9E9;
  padding: 20px;
  display: flex;
  flex-direction: column;
}
.detail-price {
  color: #F00B35;
  font-size: var(--fz-md);
  margin-top: 20px;
}
.detail-content, .detail-order-line.active {
  background-color: #F5F5F5;
}
.detail-unit, .detail-price-unit, 
.detail-customer-delivery, 
.detail-confirm-delivery, 
.detail-production-delivery {
  font-size: var(--fz-sm);
  color: #8B8B8B;
  margin-top: 5px;
} 
</style>